import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";
import { TrackedStreamField } from "../components/PageSkeleton/TrackedStreamField";
import { VideoContent } from "../components/VideoContent";
import { VideoEmbed } from "../components/VideoEmbed";

export const Template = (props: templates.EmbeddedVideoPageTemplate) => (
    <PageSkeleton {...props.page} isPreview={props.is_preview}>
        <TrackedStreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={{
                ...toolboxComponents,
                content: ({ value }) => (
                    <VideoContent
                        value={value}
                        {...props.page}
                        last_modified={new Date(props.page.last_modified)}
                    />
                ),
                video_embed: () => (
                    <VideoEmbed
                        value={{
                            embed_type:
                                props.page.embed_type === "playlist"
                                    ? "playlist"
                                    : "video",
                            embed_id: props.page.embed_id,
                        }}
                    />
                ),
            }}
        />
    </PageSkeleton>
);
